module.exports = __webpack_public_path__ + "img/ga.f64e29ed.svg";